import { render } from "./TableDefault.vue?vue&type=template&id=6814329d&scoped=true"
import script from "./TableDefault.vue?vue&type=script&lang=js"
export * from "./TableDefault.vue?vue&type=script&lang=js"

import "./TableDefault.vue?vue&type=style&index=0&id=6814329d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6814329d"]])

export default __exports__